export const sendFileChunked = async(file: Blob, fileName: string, token: string, url: string, chunkSize: number, onProgress: (current: number, total: number)=>void) => {
    const totalChunks = Math.ceil(file.size / chunkSize);
    let offset = 0;
    let lastChunkResult: any = null;
    for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
        const chunk = file.slice(offset, offset + chunkSize);
        lastChunkResult = await uploadChunk(chunk, chunkIndex, totalChunks, fileName, token, url);
        onProgress(chunkIndex, totalChunks);
        offset += chunkSize;
    }
    return lastChunkResult;
};

// Функция загрузки чанка
async function uploadChunk(chunk: Blob, chunkIndex: number, totalChunks: number, fileName: string, token: string, url: string) {
    const formData = new FormData();
    formData.append('file', chunk, `chunk-${chunkIndex}`);
    formData.append('chunkIndex', chunkIndex.toString());
    formData.append('totalChunks', totalChunks.toString());
    formData.append('fileName', fileName);
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: formData
        });

        // Проверяем, если ответ не OK
        if (!response.ok) {
            const errorText = await response.text(); // Получаем текст ошибки
            throw new Error(`Ошибка: ${response.status} - ${errorText}`); // Исключение с сообщением об ошибке
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error(error); // Выводим ошибку в консоль для отладки
    }
}
